import { render, staticRenderFns } from "./usdt-staking.vue?vue&type=template&id=a2b66136&scoped=true&"
import script from "./usdt-staking.vue?vue&type=script&lang=ts&"
export * from "./usdt-staking.vue?vue&type=script&lang=ts&"
import style0 from "./usdt-staking.vue?vue&type=style&index=0&id=a2b66136&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b66136",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow,VSpacer})
